export class DatatypesMapperModel {
    constructor(typesAndMapping) {
        Object.defineProperty(this, "datatypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "datatypesMapping", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // create a shallow copy of the datatypes, otherwise sort mutates in place
        // and causes a possible infinite render update loop.
        this.datatypes = [...typesAndMapping.datatypes];
        this.datatypes.sort();
        this.datatypesMapping = typesAndMapping.datatypes_mapping;
    }
    isSubType(child, parent) {
        const mapping = this.datatypesMapping;
        const childClassName = mapping.ext_to_class_name[child];
        const parentClassName = mapping.ext_to_class_name[parent];
        if (!childClassName || !parentClassName) {
            return false;
        }
        const childClassMappings = mapping.class_to_classes[childClassName];
        if (!childClassMappings) {
            return false;
        }
        return parentClassName in childClassMappings;
    }
    isSubTypeOfAny(child, parents) {
        return parents.some((parent) => this.isSubType(child, parent));
    }
}
